import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { UnlockPersonPhoneNumberProps as Props } from './types';
import { LoadingButton } from '@mui/lab';
import { useUnlockPeoplePhoneNumber } from '@aibees/elephant/hooks/people';
import { useBoolean } from '@aibees/shared/hooks';
import { CreditRuleCoin } from '../credit-rule-coin';
import { CreditUsageType } from '@aibees/shared/definition';

export const UnlockPersonPhoneNumber = memo(({ className, item }: Props) => {
  const { handleUnlock, loading } = useUnlockPeoplePhoneNumber(item);
  const hover = useBoolean(false);

  const handleMouseLeave = () => {
    hover.onFalse();
  };

  const handleMouseEnter = () => {
    hover.onTrue();
  };

  return (
    <Styled.Wrapper
      className={classnames('UnlockPersonPhoneNumber', className)}
      sx={SX.root}
    >
      {hover.value && !loading && (
        <CreditRuleCoin type={CreditUsageType.CONTACT_PHONE_FINDING} />
      )}
      <LoadingButton
        size="xsmall"
        variant="contained"
        color="primary"
        onClick={handleUnlock}
        loading={loading}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        Unlock
      </LoadingButton>
    </Styled.Wrapper>
  );
});

UnlockPersonPhoneNumber.displayName = 'UnlockPersonPhoneNumber';
